import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const load = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      setSettings({});
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <SiteContext.Provider value={{ settings: settings || {}, reloadSettings: load }}>
      {children}
    </SiteContext.Provider>
  );
}
